import { IconButton } from "@evergis/ui";
import React, { FC, useCallback } from "react";

import { useInfoResourceDialog } from "../../hooks/useDialogs";
import { useResourceType } from "../../hooks/useResourceType";

interface InfoIconProps {
  disabled?: boolean;
  name?: string;
  title?: string;
}

export const InfoIcon: FC<InfoIconProps> = ({ disabled, title, name }) => {
  const openInfoResourceDialog = useInfoResourceDialog();
  const [resourceType] = useResourceType();
  const openInfoDialog = useCallback(() => openInfoResourceDialog([name, resourceType]), [name, resourceType]);

  return <IconButton kind={"info"} title={title} onClick={openInfoDialog} disabled={disabled} />;
};
